import { render, staticRenderFns } from "./AddQuestionaryForm.vue?vue&type=template&id=24cca67a&scoped=true"
import script from "./AddQuestionaryForm.vue?vue&type=script&lang=js"
export * from "./AddQuestionaryForm.vue?vue&type=script&lang=js"
import style0 from "./AddQuestionaryForm.vue?vue&type=style&index=0&id=24cca67a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cca67a",
  null
  
)

export default component.exports